[
  {
    "code": "NO-02",
    "name": "Akershus"
  },
  {
    "code": "NO-09",
    "name": "Aust-Agder"
  },
  {
    "code": "NO-06",
    "name": "Buskerud"
  },
  {
    "code": "NO-20",
    "name": "Finnmark"
  },
  {
    "code": "NO-04",
    "name": "Hedmark"
  },
  {
    "code": "NO-12",
    "name": "Hordaland"
  },
  {
    "code": "NO-15",
    "name": "Møre og Romsdal"
  },
  {
    "code": "NO-17",
    "name": "Nord-Trøndelag"
  },
  {
    "code": "NO-18",
    "name": "Nordland"
  },
  {
    "code": "NO-05",
    "name": "Oppland"
  },
  {
    "code": "NO-03",
    "name": "Oslo"
  },
  {
    "code": "NO-11",
    "name": "Rogaland"
  },
  {
    "code": "NO-14",
    "name": "Sogn og Fjordane"
  },
  {
    "code": "NO-16",
    "name": "Sør-Trøndelag"
  },
  {
    "code": "NO-08",
    "name": "Telemark"
  },
  {
    "code": "NO-19",
    "name": "Troms"
  },
  {
    "code": "NO-10",
    "name": "Vest-Agder"
  },
  {
    "code": "NO-07",
    "name": "Vestfold"
  },
  {
    "code": "NO-01",
    "name": "Østfold"
  }
]